import React, { Component } from 'react'
import moment from 'moment'
import { DatePicker } from 'antd'
import './index.less'

const { MonthPicker, WeekPicker } = DatePicker
function getCalendarContainer(trigger) {
  return trigger.parentNode
}
const defaultConfig = {
  open: true,
  showToday: false,
  dropdownClassName: 'mn-daterange-item-content',
  getCalendarContainer
}
class WeekPickerAndMonthPicker extends Component {
  static defaultProps = {
    type: 'month',
    value: []
  }

  onChange = (date, str) => {
    if (this.props.type === 'week') {
      const startDate = moment(date).day(1).format('YYYY-MM-DD') // 周一日期
      const endDate = moment(date).day(7).format('YYYY-MM-DD') // 周日日期
      this.props.onChange([startDate, endDate], str)
    }
    if (this.props.type === 'month') {
      const startDate = moment(date).date(1).format('YYYY-MM-DD') // 周一日期
      const endDate = moment(date).endOf('month').format('YYYY-MM-DD') // 周日日期
      this.props.onChange([startDate, endDate], str)
    }
  }

  disabledDate(currentDate) {
    const { earlistDate } = this.props
    let before = earlistDate
    const begin = this.props.laterDate ? moment(this.props.laterDate) : moment().subtract(1, 'day').endOf('day')
    if (!this.props.checkAuth) {
      return (currentDate.isBefore(before)
        || currentDate.isAfter(moment().subtract(0, 'day').endOf('day')))
    }
    if (this.props.accountInfo.userAuthCodeList.some(m => m === 'history_no_limit')) {
      before = earlistDate
    } else if (this.props.accountInfo.userAuthCodeList.some(m => m === 'history_two_year')) {
      before = moment().subtract(2, 'year').subtract(1, 'quarter').startOf('quarter')
    } else if (this.props.accountInfo.userAuthCodeList.some(m => m === 'history_one_year')) {
      before = moment().subtract(1, 'year').subtract(1, 'quarter').startOf('quarter')
    } else if (this.props.accountInfo.userAuthCodeList.some(m => m === 'history_six_month')) {
      before = moment().subtract(6, 'month').subtract(1, 'quarter').startOf('quarter')
    }
    return moment.isMoment(currentDate) && (currentDate.isBefore(before)
      || currentDate.isAfter(begin.endOf(this.props.type)))
  }

  render() {
    const { value } = this.props
    return (
      <div className="mn-daterange noborder">
        <div className="mn-daterange-item">
          {this.props.type === 'month' && <MonthPicker allowClear={false} disabledDate={this.disabledDate.bind(this)} value={moment(value[0])} {...defaultConfig} onChange={this.onChange} placeholder="Select month" />}
          {this.props.type === 'week' && <WeekPicker allowClear={false} disabledDate={this.disabledDate.bind(this)} value={moment(value[0])} {...defaultConfig} onChange={this.onChange} placeholder="Select week" />}
        </div>
      </div>
    )
  }
}
export default WeekPickerAndMonthPicker
